export const extractApiError = (error) => {
  console.log("error: ", error);
  const response = error?.response?.data;
  console.log("response: ", response);

  if (response?.errors?.length) {
    return response.errors.map((e) => e.msg).join(", ");
  }
  if (response?.msg) {
    return response.msg;
  }
  if (response?.message) {
    return response.message;
  }

  if (error?.message) {
    return error.message;
  }

  return "Something went wrong";
};
